let SERVER_DEATILS = window.epAppData || {};

let config = {
  SERVER_BASE_URL: SERVER_DEATILS.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL,
  ENV_TYPE: SERVER_DEATILS.ENV_TYPE || process.env.REACT_APP_ENV_TYPE,
  STATION_SALT: SERVER_DEATILS.REACT_APP_STATION_SALT || process.env.REACT_APP_STATION_SALT,
  HASH_ALGO: SERVER_DEATILS.REACT_APP_HASH_ALGO || process.env.REACT_APP_HASH_ALGO,
  HASH_ROUND: SERVER_DEATILS.REACT_APP_HASH_ROUND || process.env.REACT_APP_HASH_ROUND,
  PLANT_NAME: SERVER_DEATILS.REACT_APP_PLANT_NAME || process.env.REACT_APP_PLANT_NAME
};

export default config;
